module.exports = __webpack_public_path__ + "assets/Icona_pizza_menu_laterale.711a74c3.svg";